import { render, staticRenderFns } from "./ProductRestrictions.vue?vue&type=template&id=3488bdc4&"
import script from "./ProductRestrictions.vue?vue&type=script&lang=ts&"
export * from "./ProductRestrictions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports